/* ============================================================
   Holy Ice — Ficha de producto
   1. Tallas: añade la equivalencia en cm al chip ("7"" → 17,8 cm).
   2. Material: marca cada chip de color con su metal para el swatch.
   3. Barra de compra pegada al hacer scroll.
   No depende de .he-anim: esto no es decoración, es información de compra.
   Debe verse aunque el usuario tenga reduced-motion o Save-Data.
   ============================================================ */
(function () {
	"use strict";

	if (!document.body.classList.contains("template-product")) return;

	/* ---------- 1. Tallas en cm ---------- */
	// SOLO opciones de longitud. Una talla de anillo también es un número
	// ("7"), pero es una talla US: convertirla a 17,8 cm sería mentir.
	var LENGTH_OPTION = /^(longitud|length|largo)$/i;

	function inchesToCm(v) {
		// Acepta "6.5 inches", "7", "7.5\"", "8 in"
		var m = String(v).replace(",", ".").match(/(\d+(?:\.\d+)?)/);
		if (!m) return null;
		var inches = parseFloat(m[1]);
		// Fuera de este rango no es una pulsera/cadena en pulgadas: no tocar
		if (isNaN(inches) || inches < 4 || inches > 36) return null;
		return { inches: inches, cm: inches * 2.54 };
	}

	function fmt(n, dec) {
		return n.toFixed(dec).replace(".", ",").replace(/,0$/, "");
	}

	function labelSizes() {
		document.querySelectorAll(".radio-input[data-option]").forEach(function (input) {
			if (!LENGTH_OPTION.test(input.dataset.option || "")) return;
			var label = document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
			if (!label || label.dataset.hpDone === "1") return;

			var conv = inchesToCm(input.value);
			if (!conv) return;

			label.dataset.hpDone = "1";
			label.textContent = "";

			var main = document.createElement("span");
			main.textContent = fmt(conv.inches, 1) + '"';
			var cm = document.createElement("span");
			cm.className = "hp-cm";
			cm.textContent = fmt(conv.cm, 1) + " cm";

			label.appendChild(main);
			label.appendChild(cm);
		});
	}

	/* ---------- 2. Swatch de material ---------- */
	// Los valores vienen sin normalizar de la tienda: "Oro Rosa", "oro Rosa",
	// "oro 18K", "Plata"… Se normaliza aquí y no se toca el dato del producto.
	function metalOf(value) {
		var v = String(value).toLowerCase().trim();
		if (/rosa|rose/.test(v)) return "oro-rosa";
		if (/blanc|white|rodio|rhodium/.test(v)) return "oro-blanco";
		if (/oro|gold|18k|amarill/.test(v)) return "oro";
		if (/plata|silver|925/.test(v)) return "plata";
		return null;
	}

	function markMetals() {
		document.querySelectorAll(".radio-input[data-option]").forEach(function (input) {
			if (!/^(color|colour|material|acabado)$/i.test(input.dataset.option || "")) return;
			var label = document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
			if (!label) return;
			var metal = metalOf(input.value);
			if (metal) label.setAttribute("data-hp-metal", metal);
		});
	}

	/* ---------- 3. Barra de compra pegada ---------- */
	function buildBar() {
		var form = document.querySelector('form[action*="/cart/add"]');
		if (!form || document.querySelector(".hp-bar")) return;

		var realBtn = form.querySelector('[type="submit"], [name="add"]');
		if (!realBtn) return;

		var titleEl = document.querySelector(".product-title, .product__title, h1");
		var priceEl = document.querySelector(".product-price, .price__regular, .price");
		var imgEl = document.querySelector(".product-gallery img, .product__media img");

		var bar = document.createElement("div");
		bar.className = "hp-bar";
		bar.innerHTML =
			(imgEl ? '<img class="hp-bar__media" src="' + imgEl.currentSrc + '" alt="" aria-hidden="true">' : "") +
			'<span class="hp-bar__info">' +
			'<span class="hp-bar__title"></span>' +
			'<span class="hp-bar__meta"></span>' +
			"</span>" +
			'<button class="hp-bar__cta" type="button"></button>';
		document.body.appendChild(bar);

		bar.querySelector(".hp-bar__title").textContent = titleEl ? titleEl.textContent.trim() : "";

		var cta = bar.querySelector(".hp-bar__cta");
		var meta = bar.querySelector(".hp-bar__meta");

		function sync() {
			// El precio y el texto salen del botón real: si el tema los cambia
			// al elegir variante, la barra se entera sola.
			meta.textContent = priceEl ? priceEl.textContent.trim().replace(/\s+/g, " ") : "";
			cta.textContent = (realBtn.textContent || "Añadir").trim();
			cta.disabled = realBtn.disabled;
		}
		sync();

		// No duplicamos la lógica del carrito: pulsamos el botón de verdad
		cta.addEventListener("click", function () {
			realBtn.click();
		});

		// El tema reescribe el botón al cambiar de variante
		new MutationObserver(sync).observe(realBtn, {
			childList: true,
			subtree: true,
			attributes: true,
			attributeFilter: ["disabled", "class"]
		});
		if (priceEl) new MutationObserver(sync).observe(priceEl, { childList: true, subtree: true });

		// La barra aparece cuando el botón real se pierde de vista: mientras se
		// ve, duplicarlo solo tapa producto.
		if ("IntersectionObserver" in window) {
			new IntersectionObserver(
				function (entries) {
					entries.forEach(function (en) {
						bar.classList.toggle("is-on", !en.isIntersecting && en.boundingClientRect.top < 0);
					});
				},
				{ threshold: 0 }
			).observe(realBtn);
		}
	}

	function init() {
		labelSizes();
		markMetals();
		buildBar();
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}

	// El editor de temas y los cambios de variante vuelven a pintar los radios
	document.addEventListener("shopify:section:load", init);
})();
